(function (window, document, $) {
    $(document).ready(function () {

        //Make element sticky until the footer
        if( $( '[data-wp-sticky]' ).length ) {

            var sticky = new Waypoint.Sticky({
                element: $( '[data-wp-sticky]' ),
                wrapper: '<div class="sticky-wrapper" />',
                handler: function(direction) {
                    this.element.width( this.element.parent().width() );
                },
            });

            $footer_element = false;

            if( $( '[data-wp-related]' ).length ) {
                $footer_element = $( '[data-wp-related]' );
            } else if( $( '[data-wp-footer]' ).length ) {
                $footer_element = $( '[data-wp-footer]' );
            }


            if($footer_element !== false) {
                var footerWaypoint = new Waypoint({
                    element: $footer_element,
                    handler: function(direction) {
                        $( '[data-wp-sticky]' ).toggleClass( 'stuck', direction === 'up' );
                        $( '[data-wp-sticky]' ).toggleClass( 'sticky-surpassed', direction === 'down' );
                    }, 
                    offset: function() {
                        return $( '[data-wp-sticky]' ).outerHeight()
                    }
                });
            }
        }
    });

}(window, document, jQuery));